import * as Fields from "#root/components/form/fields";
import StandardEditor, { type StandardEditorProps } from "#root/components/standard-editor";
import type { ReactNode } from "react";
import { passwordCollection, PasswordDetailItemSchema, PasswordListItemSchema } from "../../schema/password";

import PageLayout from "./layout";

export default function (): ReactNode {
  return (
    <PageLayout title="Change Password">
      <section>
        <h1>Change Password</h1>
        <p>Update your account password. You'll need to enter your current password to confirm the change.</p>
        <Editor collection={passwordCollection}/>
      </section>
    </PageLayout>
  );
}

function Editor(props: StandardEditorProps<typeof PasswordListItemSchema, typeof PasswordDetailItemSchema>) {
  return (
    <StandardEditor name="Password" {...props}>
      <Fields.Set name="oldPassword">
        <label>Old Password</label>
        <Fields.Password required name="oldPassword" autoComplete="current-password"/>
        <Fields.Validity/>
      </Fields.Set>
      <Fields.Set name="password">
        <label>New Password</label>
        <Fields.Password required autoComplete="new-password"/>
        <Fields.Validity/>
      </Fields.Set>
      <Fields.Set name="password2">
        <label>Confirm Password</label>
        <Fields.PasswordConfirm required siblingName="password" autoComplete="new-password"/>
        <Fields.Validity/>
      </Fields.Set>
    </StandardEditor>
  );
}
